export const featureAbbr = "auth"